<template>
    <div class="box">
        <div class="table">
            <div  v-for="(item, index) in data" :key="index" class="table-container">
                <div v-for="(value, name) in item" :key="name" class="table-box">
                    <div class="table-values">
                        <div class="table-name">{{name}}:</div>
                        <div>{{ value.label ? value.label : value }}</div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { currencyBRL } from '@/filters'

export default {
	name: 'repeater-table-line',

    filters: {
			currencyBRL,
		},

	props: {
        data: {
            type: Array,
            default: () => []
        }
    }
    
}
</script>

<style lang="stylus" scoped>
	@import './styles.styl'
</style>

